import { MutationTree } from "vuex";
import {
  IDashboardState,
  IBookingAggregate,
  IDashboardGraph,
  IDailyChartData,
} from "@/core/interfaces/dashboard.interface";

const mutations: MutationTree<IDashboardState> = {
  setInsightsLoading(state, payload: boolean) {
    state.isInsightsLoading = payload;
  },
  saveInsights(state, payload: IDashboardGraph) {
    state.insights = payload;
  },
  saveDailyFlightChart(state, payload: IDailyChartData) {
    state.dailyFlightChartData = payload;
  },
  saveDailyHotelChart(state, payload: IDailyChartData) {
    state.dailyHotelChartData = payload;
  },
  saveBookingAggregate(state, payload: IBookingAggregate[]) {
    state.bookingAggregate = payload;
  },
};

export default mutations;
